import type { ReactNode } from "react";

const PATTERNS: RegExp[] = [
  /\b([\w']+)\s+is\s+the\s+(verb|noun|adjective|answer|sound|word)\b/gi,
  /\b([\w']+)\s+is\s+(a|an)\s+(verb|noun|adjective)\b/gi,
];

/**
 * Wraps target vocabulary in <mark class="lp-highlight"> for child theme.
 */
export function highlightVocabulary(text: string, isChild: boolean): ReactNode {
  if (!isChild || !text) return text;

  type Span = { start: number; end: number };
  const spans: Span[] = [];

  for (const re of PATTERNS) {
    re.lastIndex = 0;
    let m: RegExpExecArray | null;
    const r = new RegExp(re.source, re.flags);
    while ((m = r.exec(text)) !== null) {
      const word = m[1];
      if (!word) continue;
      const full = m[0];
      const start = m.index + full.indexOf(word);
      const end = start + word.length;
      spans.push({ start, end });
    }
  }

  if (spans.length === 0) return text;

  spans.sort((a, b) => a.start - b.start);
  const merged: Span[] = [];
  for (const s of spans) {
    const last = merged[merged.length - 1];
    if (!last || s.start >= last.end) {
      merged.push({ ...s });
    } else {
      last.end = Math.max(last.end, s.end);
    }
  }

  const out: ReactNode[] = [];
  let i = 0;
  merged.forEach((span, idx) => {
    if (span.start > i) {
      out.push(text.slice(i, span.start));
    }
    out.push(
      <mark key={`h-${idx}`} className="lp-highlight">
        {text.slice(span.start, span.end)}
      </mark>
    );
    i = span.end;
  });
  if (i < text.length) {
    out.push(text.slice(i));
  }
  return <>{out}</>;
}
